<template>

    <div class="trax-struct-map" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">
            <div class="trax-block trax-level-1" v-for="section in sections" :key="section.id" :data-id="section.id"
                v-if="section.learning_units && section.learning_units.length > 0">

                <h3 v-if="sections.length>1">{{ section.name }}</h3>

                <div class="clearfix"></div>

                <div :id="id+'-struct-'+section.id" class="trax-block-body" :data-id="section.id">

                    <enac-atpl-dashboard-phase-map-item v-for="learning_unit in section.learning_units" :key="learning_unit.id"
                        :id="id" :bus="bus" :item="learning_unit" :states="states"
                        v-if="programUnit(learning_unit)">
                    </enac-atpl-dashboard-phase-map-item>

                    <div class="trax-btn-square trax-icon" v-if="hasGroupUnits(section)">
                        + <i class="material-icons">people_outline</i>
                    </div>

                    <enac-atpl-dashboard-phase-map-item v-for="learning_unit in section.learning_units" :key="learning_unit.id"
                        :id="id" :bus="bus" :item="learning_unit" :states="states"
                        v-if="groupUnit(learning_unit)">
                    </enac-atpl-dashboard-phase-map-item>

                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                endpoint: app_url+'polaris/api/front/sections',
                endpointParams: {
                    options: {
                        registration: data.registration.id
                    },
                    filters: {
                        phase_id: data.phase.id
                    },
                    sort: ['order']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id,
                sections: [],
                states : {}
            }
        },

        created: function() {
            this.getData();
            this.getStates();
        },

        methods: {

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            hasGroupUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.groupUnit(learning_unit)) return true;
                }
                return false;
            },

            getData() {
                var that = this;
                axios.get(that.endpoint, {params: that.endpointParams})
                    .then(function (response) {
                        that.sections = response.data.data;
                        that.loaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.states = Array.isArray(response.data.data) ? {} : response.data.data;
                    })
                    .catch(function (error) {
                    });
            }
        }
    }
</script>
